import {CoverageLevelModel} from './plans.model';

export enum SectionType {
  BENEFIT_DETAILS = 1,
  COMMON_DENTAL_PLAN_SAVINGS = 2
}

export enum DisplayMode {
  FULL = 1,
  PRICING_ONLY = 2,
  SAVINGS_ONLY = 3,
  DESCRIPTION_ONLY = 4,
  QUANTITY_PAY = 5,
  QUANTITY = 6
}

export enum SavingsSourceEnum {
  ADA_CODE = 'AdaCode',
  FEE_SCHEDULE = 'FeeSchedule'
}

export interface MarketingDetailColumnItemInterface {
  column1?: string;
  column2?: string;
  column3?: string;
}

export interface MarketingDetailColumnGroupInterface {
  itemName: string;
  value: MarketingDetailColumnItemInterface[];
}

export interface MarketingDetailItemInterface {
  description: string;
  quantity: string | null;
  youPay: number | null;
  youSave: string | null;
  hasException: boolean;
  exceptionText: string | null;
  asteriskNotation: string | null;
  memberPays: string | null;
  adaCode: string | null;
  sectionType: SectionType;
}

export interface MarketingDetailGroupInterface {
  itemName: string;
  items: MarketingDetailItemInterface[];
}

export interface MarketingDetailCategoryInterface {
  displayMode: DisplayMode;
  exceptions: MarketingDetailExceptionInterface[];
  groups: MarketingDetailGroupInterface[];
  savingsSource?: SavingsSourceEnum;
  xrayExamFooterText?: string | null;
  exclusiveDiscountStatement?: string | null;
}

export interface MarketingDetailExceptionInterface {
  notation: string;
  text: string;
}

export interface SalesPlanMarketingDetailsInterface {
  planSummary: MarketingDetailColumnGroupInterface[];
  planBenefits: MarketingDetailCategoryInterface | null;
  commonDentalPlanSavings: MarketingDetailCategoryInterface | null;
  exclusion: MarketingDetailColumnGroupInterface[];
  feeSchedule: MarketingDetailColumnGroupInterface[];
}

export interface BenefitPlanTemplateInfoInterface {
  benefitPlanTemplateId: string;
  name: string;
  benefitPlanTemplateType: string;
  isAdminBy: string;
  coverageLevels: CoverageLevelModel[];
}

export interface MarketingDetailsApiResponseInterface {
  practiceId: string;
  pageName: string;
  benefitPlanTemplate: BenefitPlanTemplateInfoInterface;
  salesPlanMarketingDetails: SalesPlanMarketingDetailsInterface;
}
